/**
 * Shared vocabulary: generic actions, states, and fallbacks reused across
 * pages. Message values are plain strings, or functions when interpolation /
 * pluralization is needed — the function signature is the contract every
 * locale must satisfy.
 */

export const common = {
  appName: 'Smith Factory',
  loading: 'Loading…',
  retry: 'Retry',
  cancel: 'Cancel',
  close: 'Close',
  back: 'Back',
  continue: 'Continue',
  or: 'or',
  optional: 'optional',
  genericError: 'Something went wrong. Please try again.',
  requestFailed: (status: number) => `Request failed (${status})`,
  sessionExpired: 'Your session has expired. Please sign in again.',
  language: 'Language',
  languageNameEn: 'English',
  languageNamePt: 'Português (Brasil)'
}
